
import { getApolloClient } from '@/apollo';
import User, { UpdateUser } from '../graphql/User';

function setProfile({ commit }, profile) {
  commit('SET_PROFILE', profile);
}

function fetchUser(apolloConfig) {
  return getApolloClient().query({
    query: User,
    ...apolloConfig,
  });
}

function updateUser(variables) {
  return getApolloClient().mutate({
    mutation: UpdateUser,
    variables,
  }).then((response) => {
    if (response.data.updateUser.status === 'success') {
      return response.data.updateUser.user;
    }
    return Promise.reject(response);
  });
}

function normalizeUser({ data }) {
  return {
    id: data.currentUser.id,
    ...data.currentUser.profile,
    balance: {
      EUR: { ...data.currentUser.balanceEUR },
      USD: { ...data.currentUser.balanceUSD },
      RUB: { ...data.currentUser.balanceRUB },
    },
  };
}

export default {
  fetchCurrentUser: ({ commit }) =>
    fetchUser({ fetchPolicy: 'no-cache' })
      .then((response) => {
        setProfile({ commit }, normalizeUser(response));
      }),
  updateUser: ({ commit }, data) => updateUser(data)
    .then((currentUser) => setProfile({ commit }, normalizeUser({
      data: { currentUser },
    }))),
};



// WEBPACK FOOTER //
// ./src/views/Profile/store/actions.js